(ns vit-configurator.views.official
  (:require [re-frame.core :as re-frame]
            [reagent.core :as reagent]
            [vit-configurator.events :as events]
            [vit-configurator.subs :as subs]))

(def official-text
  [:legend
   [:p "Set this parameter to True to return only official state data from the Google Civic Information API."]
   [:p "Note: This may result in gaps in coverage due to jurisdictions without official data.] Set to False to return official AND unofficial data."]])

(defn radio-button [id value current-value]
  (letfn [(change-fn [_]
            (re-frame/dispatch [::events/set-official-only
                                value]))]
    [:input (merge {:type "radio" :name "official" :value (str value)
                    :id id :on-change change-fn}
                   (if (= value current-value)
                     {:checked true}
                     {:checked false}))]))

(defn customizer
  []
  (let [official @(re-frame/subscribe [::subs/official-only])]
    [:fieldset#official.mb-0
     official-text
     [radio-button "official-only" true official]
     [:label.pl-1.pr-4.mb-0 {:for "official-only"} "True"]
     [radio-button "unofficial" false official]
     [:label.pl-1.mb-0 {:for "unofficial"} "False"]]))
